import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import {
  CONTEXT_MENU_CANVAS,
  ObjectMenuItems,
  CanvasMenuItems,
  TableMenuItems,
  CONTEXT_MENU_TABLE,
} from './tools/ToolMenu';
import WhiteboardController from './controllers/WhiteboardController';
import type Table from './objects/Table';

const ContextMenu = () => {
  const controller = useController(WhiteboardController);
  const selection = controller.toolbarObject();
  const { contextMenu } = controller.state;
  let menuItems: React.ReactNode;

  if (contextMenu) {
    if (contextMenu.type === CONTEXT_MENU_CANVAS) {
      menuItems = (
        <CanvasMenuItems
          controller={controller}
          selection={selection}
          showShapeAuthors={controller.state.showShapeAuthors}
          showBackgroundGrid={controller.state.showBackgroundGrid}
        />
      );
    } else if (contextMenu.type === CONTEXT_MENU_TABLE) {
      menuItems = (
        <TableMenuItems
          controller={controller}
          selection={selection as Table}
        />
      );
    } else {
      menuItems = (
        <ObjectMenuItems controller={controller} selection={selection} />
      );
    }

    if (menuItems === null) {
      return null;
    }

    // The empty <div> in the control slot is so that aha-menu doesn't crash
    // trying to find the location of the control element.
    return (
      <aha-menu
        open
        style={{
          position: 'absolute',
          left: contextMenu.x,
          top: contextMenu.y,
        }}
      >
        <div slot='control'>
          <div />
        </div>
        <aha-menu-content>{menuItems}</aha-menu-content>
      </aha-menu>
    );
  } else {
    return null;
  }
};

export default ApplicationView(ContextMenu);
